import FileName from '../../ComControl/FileName'
import AvgButtonIndex from '../../ComControl/AvgButtonIndex'
import AvgButton from '../../ComControl/AvgButton'
import Viewport from '../../ComControl/Viewport'
import CGItem from './CGItem'
import { FileReader, FileWriter } from '@/platform'
import DataUtils from '@/model/DataUtils'
import { normalizeString, writeIntBool } from '@/model/gameBinUtils'

/** 与 cg_v3 `CGAppreciate.writefromProjectBin` 一致时块首有 `writeInt(4)`；`FileName.type` 为 1/2，不会是 4 */
const PROJECT_BIN_BLOCK_TAG = 4
/** 防止错位时 cgLen 极大导致循环卡死 */
const MAX_CG_COUNT = 65535

class CGAppreciate {
    /**
     * CG鉴赏的背景图
     */
    public BackPic: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    /**
     *  CG结构体集合
     */
    public CGs: CGItem[] = []

    /**
     * 选择CG的背景图样式 project_no_bin
     */
    public BackButton: AvgButton = new AvgButton()

    /**
     * 返回按钮索引
     */
    public BackButtonEx: AvgButtonIndex = new AvgButtonIndex(0, 0, 0)

    /**
     * 关闭按钮索引
     */
    public CloseButtonEx: AvgButtonIndex = new AvgButtonIndex(0, 0, 0)

    /**
     * CG鉴赏分为几列
     */
    public Column: number = 0

    /**
     * 行间距
     */
    public SpanRow: number = 0

    /**
     * 列间距
     */
    public SpanCol: number = 0

    /**
     * 是否显示文字介绍
     */
    public IsMessage: boolean = false

    /**
     * 文字介绍的x坐标
     */
    public X: number = 0

    /**
     * 文字介绍的y坐标
     */
    public Y: number = 0

    /**
     * 显示的限制区域
     */
    public Viewport: Viewport = new Viewport()

    /**
     * 缩放率0~100的数字
     */
    public Zoom: number = 0

    /**
     * CG图的相对X坐标
     */
    public Cg_x: number = 0

    /**
     * //CG图案的相对Y坐标
     */
    public Cg_y: number = 0

    /**
     * //CG未开启的图案
     */
    public Nopic: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    /**
     * //关闭按钮 project_bin_no
     */
    public CloseButton: AvgButton = new AvgButton()

    /**
     * //按钮对应索引 project_bin_no
     */
    public BtnIndex: number[] = []

    public NameList: { name: string; startIndex: number }[] = [{ name: 'CG鉴赏1', startIndex: 0 }]

    public ListBtnIndex: AvgButtonIndex = new AvgButtonIndex()

    public ListBtnGap: number = 0

    /**列表按钮排列方向 0:横向 1:纵向 */
    public ListBtnDirection: number = 0

    constructor(param?: AvgButton[]) {
        if (Array.isArray(param)) {
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'CG.png' })
            this.CGs = [new CGItem()]
            for (let i: number = 0; i < 2; i++) {
                this.CGs.push(
                    new CGItem({
                        name: '',
                        path: new FileName({ type: FileName.DEF_TYPE, name: '' }),
                        msg: '',
                    })
                )
            }
            this.BackButton = param[0]!
            this.CloseButton = param[1]!
            this.Column = 5
            this.SpanRow = 110
            this.SpanCol = 135
            this.IsMessage = true
            this.X = 110
            this.Y = 450
            this.Viewport = new Viewport(70, 105, 673, 325)
            this.Zoom = 19
            this.Cg_x = 0
            this.Cg_y = 0
            this.Nopic = new FileName({ type: FileName.DEF_TYPE, name: '' })
            this.BtnIndex = [23, 15]
            this.BackButtonEx = new AvgButtonIndex(23, this.BackButton?.X, this.BackButton?.Y)
            this.CloseButtonEx = new AvgButtonIndex(15, this.CloseButton?.X, this.CloseButton?.Y)
        } else {
            // TODO 读取数据
        }
    }

    readBin(reader: FileReader): void {
        this.BackPic = new FileName(reader)
        this.CGs = []
        const cgLen = reader.readInt()
        if (cgLen < 0 || cgLen > MAX_CG_COUNT) {
            throw new RangeError(
                `CGAppreciate: CG count ${cgLen} out of range [0, ${MAX_CG_COUNT}]. ` +
                    `Stream is likely misaligned (check BGM block or block prefix).`
            )
        }
        for (var i = 0; i < cgLen; i++) {
            const CG = new CGItem()
            CG.readBin(reader)
            this.CGs.push(CG)
        }
        this.BackButton = new AvgButton()
        this.BackButton.readBin(reader)
        this.BackButtonEx = new AvgButtonIndex()
        this.BackButtonEx.readBin(reader)
        this.CloseButtonEx = new AvgButtonIndex()
        this.CloseButtonEx.readBin(reader)

        this.Column = reader.readInt()
        this.SpanRow = reader.readInt()
        this.SpanCol = reader.readInt()
        this.IsMessage = reader.readBool()
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Viewport = new Viewport()
        this.Viewport.readBin(reader)
        this.Zoom = reader.readInt()
        this.Cg_x = reader.readInt()
        this.Cg_y = reader.readInt()
        this.Nopic = new FileName(reader)
        this.CloseButton = new AvgButton()
        this.CloseButton.readBin(reader)
        this.BtnIndex = []
        const btnIndexLen = reader.readInt()
        for (var i = 0; i < btnIndexLen; i++) {
            let btnIndex = reader.readInt()
            this.BtnIndex.push(btnIndex)
        }
        if (DataUtils.dataVersion >= 115) {
            const len = reader.readInt()
            this.NameList = []
            for (let i = 0; i < len; i++) {
                this.NameList.push({ name: reader.readString(), startIndex: reader.readInt() })
            }
            if (this.NameList.length === 0) {
                this.NameList = [{ name: 'CG鉴赏1', startIndex: 0 }]
            }
            this.ListBtnIndex = new AvgButtonIndex()
            this.ListBtnIndex.readBin(reader)
            this.ListBtnGap = reader.readInt()
            this.ListBtnDirection = reader.readInt()
        }
    }

    writeBin(writer: FileWriter): void {
        this.BackPic.writeBin(writer)
        writer.writeInt(this.CGs.length)
        for (let i = 0; i < this.CGs.length; i++) {
            const CG = this.CGs[i]
            CG?.writeBin(writer)
        }
        this.BackButton.writeBin(writer)
        this.BackButtonEx.writeBin(writer)
        this.CloseButtonEx.writeBin(writer)
        writer.writeInt(this.Column)
        writer.writeInt(this.SpanRow)
        writer.writeInt(this.SpanCol)
        writer.writeBool(this.IsMessage)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        this.Viewport.writeBin(writer)
        writer.writeInt(this.Zoom)
        writer.writeInt(this.Cg_x)
        writer.writeInt(this.Cg_y)
        this.Nopic.writeBin(writer)
        this.CloseButton.writeBin(writer)
        writer.writeInt(this.BtnIndex.length)
        for (let i = 0; i < this.BtnIndex.length; i++) {
            writer.writeInt(this.BtnIndex[i]!)
        }
        if (DataUtils.dataVersion >= 115) {
            writer.writeInt(this.NameList.length)
            for (let i = 0; i < this.NameList.length; i++) {
                writer.writeString(this.NameList[i]!.name)
                writer.writeInt(this.NameList[i]!.startIndex)
            }
            this.ListBtnIndex.writeBin(writer)
            writer.writeInt(this.ListBtnGap)
            writer.writeInt(this.ListBtnDirection)
        }
    }

    readVersionedOui(reader: FileReader, dataVersion: number): void {
        this.BackPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.Column = reader.readInt()
        this.SpanRow = reader.readInt()
        this.SpanCol = reader.readInt()
        this.IsMessage = reader.readInt() == 1 ? true : false
        this.X = reader.readInt()
        this.Y = reader.readInt()
        this.Zoom = reader.readInt()
        this.Cg_x = reader.readInt()
        this.Cg_y = reader.readInt()
        this.Nopic.readVersionedOui(reader.readObj(reader.readInt()))

        this.CGs = []
        const cgLen = reader.readInt()
        for (var i = 0; i < cgLen; i++) {
            let CG = new CGItem()
            CG.readVersionedOui(reader.readObj(reader.readInt()))
            this.CGs.push(CG)
        }

        this.Viewport.readVersionedOui(reader.readObj(reader.readInt()))
        this.BackButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.CloseButtonEx.readVersionedOui(reader.readObj(reader.readInt()))
        if (dataVersion >= 115) {
            const len = reader.readInt()
            if (len > 0) {
                this.NameList = []
            }
            for (let i = 0; i < len; i++) {
                this.NameList.push({ name: reader.readString(), startIndex: reader.readInt() })
            }
            this.ListBtnIndex.readVersionedOui(reader.readObj(reader.readInt()))
            this.ListBtnGap = reader.readInt()
            this.ListBtnDirection = reader.readInt()
        }
    }

    writeVersionedOui(writer: FileWriter, dataVersion: number): void {
        writer.writerIntLength()

        this.BackPic.writeVersionedOui(writer)
        writer.writeInt(this.Column)
        writer.writeInt(this.SpanRow)
        writer.writeInt(this.SpanCol)
        writer.writeInt(this.IsMessage ? 1 : 0)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        writer.writeInt(this.Zoom)
        writer.writeInt(this.Cg_x)
        writer.writeInt(this.Cg_y)
        this.Nopic.writeVersionedOui(writer)

        writer.writeInt(this.CGs.length)
        for (let i = 0; i < this.CGs.length; i++) {
            const CG = this.CGs[i]
            CG.writeVersionedOui(writer)
        }

        this.Viewport.writeVersionedOui(writer)
        this.BackButtonEx.writeVersionedOui(writer)
        this.CloseButtonEx.writeVersionedOui(writer)
        if (dataVersion >= 115) {
            writer.writeInt(this.NameList.length)
            this.NameList.forEach(item => {
                writer.writeString(item.name)
                writer.writeInt(item.startIndex)
            })
            this.ListBtnIndex.writeVersionedOui(writer)
            writer.writeInt(this.ListBtnGap)
            writer.writeInt(this.ListBtnDirection)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter, engineVersion: number): void {
        writer.writerIntLength()
        this.BackPic.writeVersionedOui(writer)
        writer.writeInt(Number(this.Column || 0))
        writer.writeInt(Number(this.SpanRow || 0))
        writer.writeInt(Number(this.SpanCol || 0))
        writeIntBool(writer, this.IsMessage)
        writer.writeInt(Number(this.X || 0))
        writer.writeInt(Number(this.Y || 0))
        writer.writeInt(Number(this.Zoom || 0))
        writer.writeInt(Number(this.Cg_x || 0))
        writer.writeInt(Number(this.Cg_y || 0))
        this.Nopic.writeVersionedOui(writer)

        const items = Array.isArray(this.CGs) ? this.CGs : []
        writer.writeInt(items.length)
        for (let i = 0; i < items.length; i++) {
            items[i]?.writeGameBin(writer)
        }

        this.Viewport.writeVersionedOui(writer)
        this.BackButtonEx.writeVersionedOui(writer)
        this.CloseButtonEx.writeVersionedOui(writer)

        if (engineVersion >= 110) {
            const nameList = Array.isArray(this.NameList) ? this.NameList : []
            writer.writeInt(nameList.length)
            for (let i = 0; i < nameList.length; i++) {
                const item = nameList[i]
                writer.writeString(normalizeString(item?.name))
                writer.writeInt(Number(item?.startIndex || 0))
            }
            this.ListBtnIndex.writeVersionedOui(writer)
            writer.writeInt(Number(this.ListBtnGap || 0))
            writer.writeInt(Number(this.ListBtnDirection || 0))
        }

        writer.writerLength()
    }
}

export default CGAppreciate
